import React, { useEffect, useState } from 'react';
import { Card, Table, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { getRimborsiPerCliente } from '../services/api';

const formatData = (d) => (d ? new Date(d).toLocaleDateString('it-IT') : '-');

// Anagrafica cliente: ordini rimborsati con motivo. Non mostra nulla se il cliente non ne ha.
function StoricoRimborsiCliente({ clienteId }) {
  const [rimborsi, setRimborsi] = useState([]);

  useEffect(() => {
    getRimborsiPerCliente(clienteId)
      .then((res) => setRimborsi(res.data))
      .catch((err) => console.error('Errore nel caricamento dei rimborsi del cliente:', err));
  }, [clienteId]);

  if (rimborsi.length === 0) return null;

  return (
    <Card className="mb-4 border-dark">
      <Card.Header>Storico rimborsi ({rimborsi.length})</Card.Header>
      <Card.Body>
        <Table size="sm" bordered responsive className="mb-0">
          <thead>
            <tr><th>Ordine</th><th>Rimborsato il</th><th className="text-end">Importo</th><th>Motivo</th></tr>
          </thead>
          <tbody>
            {rimborsi.map((r) => (
              <tr key={r.id}>
                <td><Link to={`/ordini/${r.id}`}>#{r.id}</Link></td>
                <td>{formatData(r.data_rimborso)}</td>
                <td className="text-end">€ {Number(r.totale_ordine || 0).toFixed(2)}</td>
                <td>
                  {r.motivo_rimborso ? <Badge bg="secondary">{r.motivo_rimborso}</Badge> : <span className="text-muted">Non indicato</span>}
                  {r.note_rimborso && <small className="text-muted d-block">{r.note_rimborso}</small>}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}

export default StoricoRimborsiCliente;
